module.exports = __webpack_public_path__ + "img/j.0061fde9.jpg";